import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FlexRow } from '@app/flex-framework/flex-api.model';
import { LinkRowLink } from '@app/shared/components/link-row/link-row.model';
import { MenuViewModel } from '@app/shared/components/menu/menu.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dgx-carousel-header',
  templateUrl: './carousel-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselHeaderComponent {
  @Input() public row: FlexRow;
  @Input() public carouselLoading: boolean;
  @Input() public hideLinks: boolean;
  @Input() public isEditing: boolean;
  @Input() public label: string;
  @Input() public links: LinkRowLink[];
  @Input() public markdownDescription: string;
  @Input() public menuConfig: MenuViewModel[];
  @Input() public isEndOfCarousel: boolean;
  @Input() public isBeginningOfCarousel: boolean;
  @Input() public hideReorderButton: boolean = false;
  @Input() public hideQuickEditHeader: boolean = false;

  @Output() public swipeTo: EventEmitter<boolean | undefined> =
    new EventEmitter();

  public i18n = this.translateService.instant([
    'dgCarousel_ShowPreviousItems',
    'dgCarousel_ShowNextItems',
  ]);

  constructor(private translateService: TranslateService) {}
}
